"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useDeviceWidth = () => {
    let initialWidth;
    try {
        // During SSR on Next.js, the `window` is not defined,
        // which throws an error.
        // Should not affect traditional React applications
        initialWidth = window.innerWidth;
    }
    catch (_) {
        initialWidth = 0;
    }
    const [deviceWidth, setDeviceWidth] = (0, react_1.useState)(initialWidth);
    (0, react_1.useEffect)(() => {
        const handleViewportResize = () => setDeviceWidth(window.innerWidth);
        window.addEventListener("resize", handleViewportResize);
        return () => {
            window.removeEventListener("resize", handleViewportResize);
        };
    });
    return deviceWidth;
};
exports.default = useDeviceWidth;
//# sourceMappingURL=use-device-width.js.map